import { render, staticRenderFns } from "./ContentDiv.vue?vue&type=template&id=319d774f&scoped=true&"
import script from "./ContentDiv.vue?vue&type=script&lang=js&"
export * from "./ContentDiv.vue?vue&type=script&lang=js&"
import style0 from "./ContentDiv.vue?vue&type=style&index=0&id=319d774f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319d774f",
  null
  
)

export default component.exports